import React from 'react';
import {Row, Col} from 'react-bootstrap';
import Checkbox from 'components/shared/StandaloneCheckbox';
import {connect} from 'react-redux';
import {getIssuesComponent, getErrorIssues, getWarningIssues} from '../../../../../../../utils/validationSummary';
import BigInteger from 'big-integer';

class LumInfoForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.isOn(this.props.property) ? this.props.property.value : '',
            isEnabled: this.props.property.value !== "Off",
            isChecked: this.props.property.value !== "Off",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
        this.handleChangeNumber64 = this.handleChangeNumber64.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.property.value !== prevProps.property.value) {
            this.setState({
                value: this.isOn(this.props.property) ? this.props.property.value : ''
            });
        }
    }

    isOn(property) {
        return property.value !== undefined
            && property.value !== null
            && property.value !== ''
            && property.value.toUpperCase() !== 'OFF'
            && property.value !== property.valueMeta.off;
    }

    handleChange(e) {
        const value = e.target.value;
        this.setState({
            value: value,
        });
        this.props.handleChange(this.props.property.info.name, value ? value : "Off");
    }

    handleChangeNumber64(e) {

        const stringValue = e.target.value !== null ? e.target.value.replace(/^\D+/g, '') : 0;

        const value = BigInteger(stringValue);
        if (value <= BigInteger(e.target.max) && value >= BigInteger(e.target.min)) {
            this.setState({
                value: value.toString(),
            });

            this.props.handleChange(this.props.property.info.name, value ? value.toString() : "Off");
        }
    }

    handleChangeEnabled(e) {
        const value = e.target.checked;

        if (value && (this.props.property.value === 'Off')) {
            const initial = this.props.property.valueMeta.initial;
            this.setState({
                value: initial
            });
            this.props.handleChange(this.props.property.info.name, initial);
        } else if (!value) {
            this.setState({
                value: ''
            });
            this.props.handleChange(this.props.property.info.name, 'Off');
        }

        this.setState({
            isChecked: value
        });
    }

    renderForm(className) {
        const pValue = this.props.auto ? "" : this.state.value;
        switch (this.props.type) {
            case "number":
                return (
                    <input
                        className={className}
                        name={this.props.property.info.name}
                        type={this.props.type}
                        min={this.props.min}
                        max={this.props.max}
                        step={this.props.step}
                        maxLength={this.props.maxLength}
                        value={pValue}
                        disabled={this.props.auto}
                        onChange={this.handleChange}/>);
            case "number64":
                return (
                    <input
                        className={className}
                        name={this.props.property.info.name}
                        type={"text"}
                        min={this.props.min}
                        max={this.props.max}
                        step={this.props.step}
                        maxLength={this.props.maxLength}
                        value={pValue}
                        disabled={this.props.auto}
                        onChange={this.handleChangeNumber64}/>);
            case "text":
                return (
                    <textarea
                        className={className}
                        name={this.props.property.info.name}
                        min={this.props.min}
                        max={this.props.max}
                        maxLength={this.props.maxLength}
                        value={pValue}
                        disabled={this.props.auto}
                        onChange={this.handleChange}
                    />);
            default:
                return null;
        }
    }

    render() {

        const errors = getErrorIssues(this.props.issues, this.props.property);
        const warnings = getWarningIssues(this.props.issues, this.props.property);

        let className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

        let classNameTitle = '';

        if (!this.state.isChecked) {
            className += ' card-disabled';
            classNameTitle += ' card-disabled';
            //className += ' card-none';
        }

        if (this.props.disabled) {
            return null;
        }

        return (
            <Row style={{margin: "0.75rem auto 0"}}>
                <Col sm={1} style={{padding: '0', margin: 'auto'}}>
                    <Checkbox
                        checked={this.state.isChecked}
                        onChange={this.handleChangeEnabled}/>
                </Col>

                <Col sm={6} className={classNameTitle} style={{margin: "auto"}}>
                    {this.props.title}
                </Col>

                <Col sm={5} style={{paddingRight: '0'}}>
                    {this.renderForm(className)}
                    {getIssuesComponent(errors, warnings)}
                </Col>
            </Row>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LumInfoForm);
